module.exports = __webpack_public_path__ + "static/media/4.9bc43c4e.jpg";